'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var SendXMLHttpRequest = function SendXMLHttpRequest(url, data, success, error, fail) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
                try {
                    if (xhr.responseText == 'ok') {
                        var response = {
                            code: 0,
                            danmaku: xhr.responseText
                        };
                    } else {
                        response = JSON.parse(xhr.responseText);
                    }
                } catch (err) {
                    response = {
                        code: 0,
                        danmaku: xhr.responseXML
                    };
                }
                if (response.code !== 0) {
                    return error(xhr, response);
                }
                return success(xhr, response);
            }
            fail(xhr);
        }
    };
    xhr.open(data !== null ? 'POST' : 'GET', url, true);
    if (data) {
        if (data.datatype == 'send') {
            xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            var data_s = '';
            for (var abcd in data) {
                data_s = data_s + abcd + '=' + data[abcd] + '&';
            }
            data = data_s;
        }
    }
    xhr.send(data !== null ? data : null);
};
function chg_color(col) {
    var num = parseInt(col);
    num = num.toString(16);
    while (num.length < 6) {
        num = '0' + num;
    }
    return '#' + num;
}
exports.default = {
    send: function send(endpoint, danmakuData, callback) {
        SendXMLHttpRequest(endpoint, danmakuData, function (xhr, response) {
            console.log('Post danmaku: ', response.danmaku);
            if (callback) {
                callback();
            }
        }, function (xhr, response) {
            alert(response.msg);
        }, function (xhr) {
            console.log('Request was unsuccessful: ' + xhr.status);
        });
    },
    read: function read(endpoint, callback) {
        SendXMLHttpRequest(endpoint, null, function (xhr, response) {
            var d_list = response.danmaku.querySelectorAll('d');
            var danmaku_pool = new Array();
            for (var d = 0; d < d_list.length; d++) {
                var strs = d_list[d].getAttribute('p').split(',');
                strs[3] = chg_color(strs[3]);
                strs[4] = strs[4];
                strs.push(d_list[d].innerHTML);
                var apha = {
                    time: strs[0],
                    type: strs[1],
                    font_size: strs[2],
                    color: strs[3],
                    addtime: strs[4],
                    text: strs[5]
                };
                var dan = [
                    apha.time,
                    apha.type,
                    apha.color,
                    'smith',
                    apha.text,
                    apha.addtime
                ];
                danmaku_pool.push(dan);
            }
            callback(null, danmaku_pool);
        }, function (xhr, response) {
            callback({
                status: xhr.status,
                response: response
            });
        }, function (xhr) {
            callback({
                status: xhr.status,
                response: null
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/js/api.js
// module id = 11
// module chunks = 0